var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2715_130736",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2715_130736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41699 34.583V31.917L7.49999 29.833V34.583H5.41699ZM12.208 34.583V25.25L14.292 23.167V34.583H12.208ZM18.958 34.583V23.167L21.042 25.292V34.583H18.958ZM25.708 34.583V25.292L27.833 23.208V34.583H25.708ZM32.5 34.583V18.583L34.583 16.5V34.583H32.5Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 10.5L5.19531 22V24.5L16.6953 14L23.1953 20L34.6953 9V6L23.1953 17L16.6953 10.5Z",
    fill: "#A9CF3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increase-icon.106139e363e686a5f903be6f3a15d72b.svg";
export { ForwardRef as ReactComponent };